import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { AcademySettings } from './../models/academy-settings';

@Injectable({
    providedIn: 'root'
})

export class AcademySettingsService {
    controller = 'AcademySettings';

    constructor(private base: BaseService) { }

    getAll(): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetAll')
    }

    getById(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetById/'+ id)
    }

    getBySettingName(settingName: string): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetById/'+ settingName)
    }

}